<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wfHs1J/tc-custom/9781452124414.jpg?1729379497858" alt="This image is the cover for the book Mastering Homebrew"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mastering Homebrew
      </h1>
      <p class="bookDescription body article font2">
        <p><b>An accessible guide to making your own beer, for beginning &amp; advanced brewers, with thirty recipes and tips for choosing ingredients, equipment, and more.</b></p><p><i>Mastering Homebrew</i> will have you thinking like a scientist, brewing like an artist, and enjoying your very own unbelievably great handcrafted beer in record time. Internationally known brewing instructor, beer competition judge, author, and brew master himself, Randy Mosher covers everything that beginning to advanced brewers want to know, all in this easy-to-follow, fun-to-read handbook, including: </p><p> ·      The anatomy of a beer </p><p> ·      Brewing with both halves of your brain </p><p> ·      Gear and the brewing process </p><p> ·      Care and feeding of yeast </p><p> ·      Hops (the spice of beer) </p><p> ·      Brewing your first beer </p><p> ·      Beer styles and beyond </p><p> ·      The Amazing Shape-Shifting Beer Recipe </p><p> ·      And more </p><b>“Randy is a walking encyclopedia of beer and brewing, and his palate and taste are impeccable.” —from the foreword by Jim Koch, chairman and cofounder, the Boston Beer Company</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Randy Mosher
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?b174f8a8